import React from "react";
import { Route, Routes } from "react-router-dom";
import StoreManagerDashboard from "../../pages/dashboard/StoreManagerDashboard";
import AuthorizeWarehouseRequisitions from "../../pages/StoresRequisition/AuthorizeWarehouseRequisition";
import SuppliedWarehouseRequisition from "../../pages/StoresRequisition/SuppliedWarehouseRequisition";
import RejectedWarehouseRequisition from "../../pages/StoresRequisition/RejectedWarehouseRequisition";
import DispatchedWarehouseRequisition from "../../pages/StoresRequisition/DispatchedWarehouseRequisition";
import ApprovedWarehouseRequisition from "../../pages/StoresRequisition/ApprovedWarehouseRequisition";

const StoreManagerRoutes = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<StoreManagerDashboard />} />
      <Route
        path="requisition/pending"
        element={<AuthorizeWarehouseRequisitions />}
      />
      <Route
        path="requisition/supplied"
        element={<SuppliedWarehouseRequisition />}
      />
      <Route
        path="requisition/rejected"
        element={<RejectedWarehouseRequisition />}
      />
      <Route
        path="requisition/approved"
        element={<ApprovedWarehouseRequisition />}
      />
      <Route
        path="requisition/dispatched"
        element={<DispatchedWarehouseRequisition />}
      />
    </Routes>
  );
};

export default StoreManagerRoutes;
